import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { BlankComponent } from './layouts/blank/blank.component';
import { FullComponent } from './layouts/full/full.component';
import { AuthGuard } from '@auth-suite-services/services';
import { CallbackComponent } from './callback/callback.component';
import { UnauthorizedComponent } from './components/unauthorized/unauthorized.component';

const routes: Routes = [
  {
    path: '',
    component: FullComponent,
    children: [
      {
        path: '',
        // App home when signed in. Unauthenticated users are sent to /landingpage by AuthGuard.
        redirectTo: '/dashboards/dashboard1',
        pathMatch: 'full',
      },
      {
        path: 'starter',
        loadChildren: () =>
          import('./pages/pages.module').then((m) => m.PagesModule),
      },
      {
        path: 'dashboards',
        loadChildren: () =>
          import('./pages/dashboards/dashboards.module').then(
            (m) => m.DashboardsModule
          ),
        canActivate: [AuthGuard],
      },
      {
        path: 'ui-components',
        loadChildren: () =>
          import('./pages/ui-components/ui-components.module').then(
            (m) => m.UicomponentsModule
          ),
        canActivate: [AuthGuard],
      },
      {
        path: 'forms',
        loadChildren: () =>
          import('./pages/forms/forms.module').then((m) => m.FormModule),
        canActivate: [AuthGuard],
      },
      {
        path: 'charts',
        loadChildren: () =>
          import('./pages/charts/charts.module').then((m) => m.ChartsModule),
        canActivate: [AuthGuard],
      },
      {
        path: 'apps',
        loadChildren: () =>
          import('./pages/apps/apps.module').then((m) => m.AppsModule),
        canActivate: [AuthGuard],
      },
      {
        path: 'widgets',
        loadChildren: () =>
          import('./pages/widgets/widgets.module').then((m) => m.WidgetsModule),
        canActivate: [AuthGuard],
      },
      {
        path: 'tables',
        loadChildren: () =>
          import('./pages/tables/tables.module').then((m) => m.TablesModule),
        canActivate: [AuthGuard],
      },
      {
        path: 'fin',
        loadChildren: () =>
          import('./FinancialSetup/financial.module').then(
            (m) => m.FinancialModule
          ),
        canActivate: [AuthGuard],
      },
      {
        path: 'theme-pages',
        loadChildren: () =>
          import('./pages/theme-pages/theme-pages.module').then(
            (m) => m.ThemePagesModule
          ),
        canActivate: [AuthGuard],
      },
      {
        path: 'access',
        loadChildren: () =>
          import('./access/access.module').then((m) => m.AccessModule),
        canActivate: [AuthGuard],
      },
      {
        path: 'portal',
        loadChildren: () =>
          import('./portal/portals.module').then((m) => m.PortalsModule),
        canActivate: [AuthGuard],
      },
      {
        path: 'mad',
        loadChildren: () =>
          import('./merchantadmin/mad.module').then(
            (m) => m.MerchantAdminModule
          ),
        canActivate: [AuthGuard],
      },
      // Maintenance browse (FIN Core module) 24/08/2026 DW
      {
        path: 'maintenance',
        loadChildren: () =>
          import('./fincore/fincore.module').then((m) => m.FinCoreModule),
        canActivate: [AuthGuard],
      },
      {
        path: 'sms',
        loadChildren: () => import('./sms/sms.module').then((m) => m.SmsModule),
        canActivate: [AuthGuard],
      },
      // Dashboard notice / home content admin. 20/10/2026 DW
      {
        path: 'noticeboard',
        loadChildren: () =>
          import('./noticeboard/noticeboard.module').then(
            (m) => m.NoticeBoardModule
          ),
        canActivate: [AuthGuard],
      },

      {
        path: 'pli',
        loadChildren: () =>
          import('./product-list/product-list.module').then(
            (m) => m.ProductListModule
          ),
        canActivate: [AuthGuard],
      },
      // added                07/06/24 CN
      {
        path: 'user',
        loadChildren: () => import('./user/user.module').then((m) => m.UserModule),
        canActivate: [AuthGuard]
      },
      {
        path: 'auth0',
        loadChildren: () => import('./auth0/auth0.module').then(m => m.Auth0Module),
        // loadChildren: './auth0/auth0.module#Auth0Module',
        canActivate: [ AuthGuard ]
      },
    ],
  },
  {
    path: '',
    component: BlankComponent,
    children: [
      {
        path: 'authentication',
        loadChildren: () =>
          import('./pages/authentication/authentication.module').then(
            (m) => m.AuthenticationModule
          ),
      },
      {
        path: 'landingpage',
        loadChildren: () =>
          import('./pages/theme-pages/landingpage/landingpage.module').then(
            (m) => m.LandingPageModule
          ),
      },
    ],
  },
  {
    path: 'unauthorized',
    component: UnauthorizedComponent,
  },
  {
    path: 'callback',
    component: CallbackComponent,
  },
  { path: 'unauthorized',
  component: UnauthorizedComponent,
},
{
  path: 'callback',
  component: CallbackComponent,
},
{ path: '**', redirectTo: '' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
